import script from "./DataIngestionHistoryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionHistoryTable.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionHistoryTable.vue?vue&type=style&index=0&id=dfdd46e8&lang=scss"

const __exports__ = script;

export default __exports__